import _typeof from "@babel/runtime/helpers/esm/typeof";

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isObject(x) {
  return x != null && _typeof(x) === 'object';
}